<template>
  <div
    class="truforme__option-container d-flex"
    :class="{ selected, disabled }"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <div class="flex-grow-1">
      <h2 :class="{ 'mt-1': !!$slots.title }">
        <slot name="title" />
      </h2>
      <h3 style="color: #64748b; font-weight: 600" v-if="$slots.subtitle">
        <slot name="subtitle" />
      </h3>
      <p style="color: #64748b" class="mt-1" v-if="$slots.body">
        <slot name="body" />
      </p>
    </div>
    <div>
      <v-btn large icon :color="selected ? 'success' : ''" :disabled="disabled">
        <v-icon :large="$vuetify.breakpoint.mdAndUp">{{
          selected ? 'mdi-check-circle' : 'mdi-checkbox-blank-circle-outline'
        }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.truforme__option-container {
  position: relative;
  overflow: hidden;
  padding: 16px;
  background-color: white;
  border-radius: 16px;
  border: 2px solid #cbd5e1;

  &:not(.disabled) {
    cursor: pointer;
  }

  &.selected {
    border: 2px solid transparent;
    outline: 4px solid var(--v-primary-base);

    h2 {
      color: var(--v-primary-darken1);
    }
  }
  &.disabled {
    background-color: color-mix(in srgb, #cbd5e1 20%, #ffffff 80%);
  }
}

@media all and (max-width: 768px) {
  .truforme__option-container {
    h2 {
      font-size: 1rem;
    }

    h3,
    p {
      font-size: 0.8rem;
    }
  }
}
</style>
<script>
export default {
  props: {
    disabled: Boolean,
    selected: Boolean,
  },
};
</script>
